<template>
  <div id="filezilla">
    <el-dialog
      title="Guide to access files with FileZilla"
      width="60%"
      :visible.sync="localVisible"
      append-to-body
      @close="$emit('update:visible', false)"
    >
      <el-button icon="mdi mdi-download" @click.prevent="download">Download FileZilla</el-button>

      <el-tabs>
        <el-tab-pane label="Add key file">
          <el-alert type="info" :closable="false">
            <div slot="title">
              Find where your <strong>private ssh key</strong> is saved
            </div>

            this can be your personal key or the key generated with
            <router-link to="/account">our online tool</router-link>
          </el-alert>

          <el-alert
            type="warning"
            title="Do not forget to click OK to save the key"
            :closable="false"
            show-icon
          />

          <img src="../../assets/guides/filezilla-key.png" />
        </el-tab-pane>

        <el-tab-pane label="Connect">
          Fill in the following information
          &ndash; host : <el-tag type="info" size="mini">{{ host }}</el-tag>
          &ndash; username : <el-tag type="info" size="mini">{{ username }}</el-tag>
          &ndash; port : <el-tag type="info" size="mini">{{ port }}</el-tag>

          <img src="../../assets/guides/filezilla-connect.png" />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    host: String,
    username: String,
    port: Number
  },
  data () {
    return {
      localVisible: this.visible
    }
  },
  methods: {
    download () {
      window.open('https://filezilla-project.org', '_blank')
    }
  },
  watch: {
    visible (value) {
      this.localVisible = value
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tabs {
  margin-top: 15px;

  .el-alert--warning {
    margin-top: 10px;
  }
}
img {
  max-width: 100%;
}
</style>

<style lang="scss">
#filezilla {
  .el-dialog__body {
    padding-top: 0;
  }
}
</style>
